import { BaseParam } from '../base-param';

export  class ItemSearchParams extends BaseParam
{
    itemidlist: number[] = []
    ItemTypeid: number
    page: number =1
    pagesize: number =1
    FromDate: string
    Todate: string
    salesChannelId: number
    geturlforsearch() {

        return "itemSearchFilter.ItemIds=" + this.getitemidlist() + "&itemSearchFilter.ItemTypeid=" + this.ItemTypeid + "&itemSearchFilter.FromDate=" + this.FromDate + "&itemSearchFilter.ToDate=" + this.Todate + "&itemSearchFilter.SalesChannelId=" + this.salesChannelId
            + "&include=itemPriceGroups,ItemAssets,itemQuestion,itemSalesChannels,UserDefinedFields,UserDefinedFieldData";
    }

    getitemidlist() {

        return this.itemidlist.join(",");
    }

}